import { BodyText, HeadlineText } from '@calendly/ui/components/typography'

import styles from './Header.module.css'

export const Header = ({ title, subtitle }) => (
  <div className={styles.headerContainer}>
    <div className={styles.titleTextContainer}>
      <HeadlineText size="medium">
        {title}
      </HeadlineText>
    </div>
    <div className={styles.subtitleTextContainer}>
      <BodyText color="muted" size="large">
        {subtitle}
      </BodyText>
    </div>
  </div>
)
